import { render, staticRenderFns } from "./DiagnosticReports.vue?vue&type=template&id=0aa25da2&scoped=true&"
import script from "./DiagnosticReports.vue?vue&type=script&lang=js&"
export * from "./DiagnosticReports.vue?vue&type=script&lang=js&"
import style0 from "./DiagnosticReports.vue?vue&type=style&index=0&id=0aa25da2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa25da2",
  null
  
)

export default component.exports